import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Menu, MenuItem } from '@mui/material';
import Icon from '@mdi/react';
import { mdiDotsHorizontal } from '@mdi/js';
import PopupTitle from '../common/popup_title';
import StopProgramConfirmPopover from './stop_program_confirm_popover';

const SharedProgrammeWithUserEnrolledPopupMenu = ({
  isCompleted,
  onStopProgram,
  onStartProgram,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = !!anchorEl;

  const [confirmPopupAnchorEl, setConfirmPopupAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStopProgram = (shouldClearPlanner) => {
    handleClose();
    onStopProgram(shouldClearPlanner);
  };

  return (
    <>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        PaperProps={{
          style: { minWidth: '250px' },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        <PopupTitle
          titleText="Program actions"
          closeButtonEnabled
          onClickClose={handleClose}
        />
        {!isCompleted && (
          <MenuItem onClick={(ev) => setConfirmPopupAnchorEl(ev.target)}>
            Stop program
          </MenuItem>
        )}
        {isCompleted && (
          <MenuItem onClick={onStartProgram}>Restart program</MenuItem>
        )}
      </Menu>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls="long-menu"
        aria-expanded={open && 'true'}
        aria-haspopup="true"
        size="small"
        className="actionsPopupMenu"
        onClick={handleClick}>
        <Icon path={mdiDotsHorizontal} />
      </IconButton>
      {confirmPopupAnchorEl && (
        <StopProgramConfirmPopover
          onConfirm={handleStopProgram}
          onDismiss={() => setConfirmPopupAnchorEl(null)}
          anchorEl={confirmPopupAnchorEl}
          visible
        />
      )}
    </>
  );
};

SharedProgrammeWithUserEnrolledPopupMenu.propTypes = {
  isCompleted: PropTypes.bool.isRequired,
  onStopProgram: PropTypes.func.isRequired,
  onStartProgram: PropTypes.func.isRequired,
};

export default SharedProgrammeWithUserEnrolledPopupMenu;
